import { BaseApiClient } from "./BaseApiClient";
export const SPORT_ENDPOINTS = {
    ALL: "/Sports",
    GROUPED_BY_DATE: "/Sports/GetGroupedByDate",
    PERSONALIZED_PRELIVE: "/Sports/GetPersonalizedPreLiveSports"
};
/**
 * SportsApiClient - client for fetching Sports BFF endpoints
 * @export
 * @class SportsApiClient
 * @extends {BaseApiClient}
 */
export class SportsApiClient extends BaseApiClient {
    /**
     * Fetch all sports from BFF
     * @param {request} SportsRequest
     * @throws {RequiredError}
     * @memberof SportsApiClient
     */
    getAllSports(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(SPORT_ENDPOINTS.ALL, fetchOptions);
    }
    /**
     * Get sports grouped by Date from BFF
     * @param {request} SportsGroupedByDateRequest
     * @throws {RequiredError}
     * @memberof SportsApiClient
     */
    getSportsGroupedByDate(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(SPORT_ENDPOINTS.GROUPED_BY_DATE, fetchOptions);
    }
    /**
     * Get all personalized sports
     * @param {PersonalizedSportsRequest} request
     * @throws {RequiredError}
     * @memberof SportsApiClient
     */
    getPersonalizedPreLiveSports(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(SPORT_ENDPOINTS.PERSONALIZED_PRELIVE, fetchOptions);
    }
}
//# sourceMappingURL=SportsApiClient.js.map